import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { verifyTokenExpire } from "middleware/verifyToken";
import { DeleteConfirmation } from "views/components/ConfirmationAlert";
import { confirmDeleteConfig } from "config/confirmConfig";
import { ToastBottomEnd } from "views/components/Toast";
import {
  toastDeleteErrorMessageConfig,
  toastDeleteSuccessMessageConfig,
} from "config/toastConfig";
import appConfig from "config/appConfig";

export const useReportingMetadata = () => {
  const [loading, setLoading] = useState(true);
  const [component, setComponent] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (!verifyTokenExpire()) return;

      try {
        setLoading(true);
        const response = await axios.get(
          `${appConfig.apiDomaine}/reporting-metadata`
        );
        setComponent(response.data);
      } catch (error) {
        console.error("Error fetching reporting metadata:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const deleteComponent = useCallback(async (id, index) => {
    try {
      const result = await DeleteConfirmation.fire(confirmDeleteConfig);

      if (result.value) {
        if (!verifyTokenExpire()) return;

        await axios.delete(
          `${appConfig.apiDomaine}/my/reporting-claim/config/${id}`
        );

        setComponent((prevComponent) => {
          const newComponent = [...prevComponent];
          newComponent.splice(index, 1);
          return newComponent;
        });

        ToastBottomEnd.fire(toastDeleteSuccessMessageConfig);
      }
    } catch (error) {
      console.error("Error deleting component:", error);
      ToastBottomEnd.fire(toastDeleteErrorMessageConfig);
    }
  }, []);

  return {
    loading,
    component,
    deleteComponent,
  };
};
